import { useCallback, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchSkills } from '../redux/SkillReducer/skillSlice';
import { formatSkillDescriptions } from '../utils/skillUtils';

/**
 * Loads the skill lookup for a site (if not already loaded) and returns a
 * formatter that converts a comma-separated list of skill codes into a
 * comma-separated list of skill descriptions.
 */
const useSkillLabels = (siteCd?: string | null) => {
    const dispatch = useAppDispatch();
    const { skills, loading } = useAppSelector((state) => state.skills);

    useEffect(() => {
        if (siteCd && skills.length === 0 && !loading) {
            dispatch(fetchSkills(siteCd));
        }
    }, [dispatch, siteCd, skills.length, loading]);

    const skillLabelByCd = useMemo(() => {
        const map: Record<string, string> = {};
        skills.forEach((s) => {
            map[s.lookupValueCd] = s.lookupValueDesc;
        });
        return map;
    }, [skills]);

    const formatSkills = useCallback(
        (raw?: string | null) => formatSkillDescriptions(raw, skillLabelByCd),
        [skillLabelByCd]
    );

    return { skillLabelByCd, formatSkills };
};

export default useSkillLabels;
